import axios from "axios";
import Cookies from "js-cookie";

const axiosConfig = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Optionally add interceptors for request and response
axiosConfig.interceptors.request.use(
  (config) => {
    // Add authorization token if available
    const token = Cookies.get("access_token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


export default axiosConfig;
